export default {
    products: [],
    productNameToCreate: '',
    productDeletionPending: [],
    posts: [],
    rates: [],
    chara: [],
    geoPoints: [],
    hiddenPosts: [],
    randomPost: [],
    productCreationPending: false,
    active: null,
};